import { cn } from '@/shared/lib/cn'

interface MeepleProps {
  /** Tamaño en px (size-{N} de tailwind). */
  size?: number
  className?: string
  'aria-hidden'?: boolean
}

/**
 * Icono meeple — la pieza icónica del board gaming moderno (Carcassonne et al).
 * SVG inline reutilizable; el color del relleno se hereda con
 * {@code currentColor}, así el padre controla el estado activo/inactivo
 * cambiando {@code text-yellow} / {@code text-muted-foreground/30}.
 *
 * <p>Usado en {@code MeepleScore} (rating UI), {@code RatingBadge} (cards y
 * profile) y cualquier sitio futuro que necesite mostrar valoración.</p>
 */
export function Meeple({ size = 24, className, ...rest }: MeepleProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={cn('shrink-0', className)}
      aria-hidden={rest['aria-hidden']}
    >
      {/* Cabeza */}
      <circle cx="12" cy="5" r="3" />
      {/* Cuerpo con brazos extendidos: T arriba, trapezoide abajo */}
      <path d="M3 11.5 C3 10.4 3.9 9.5 5 9.5 L19 9.5 C20.1 9.5 21 10.4 21 11.5 L21 13 L17 12 L17 21 C17 21.6 16.6 22 16 22 L13 22 L13 16 L11 16 L11 22 L8 22 C7.4 22 7 21.6 7 21 L7 12 L3 13 Z" />
    </svg>
  )
}
